import React from 'react';
import smartphone from '../../../../../assets/modal/smartphone.png';

const StartRecordingSuccess = ({canSendSms}) => {
	return (
		<div className='start-recording-success'>
			{/* prettier-ignore */}
			<h3>{`Check Your ${(canSendSms) ? 'Text Messages' : 'Email'}`}</h3>
			<img
				className='start-recording-success-image'
				src={smartphone}
				alt='smartphone'
			/>
			<p>
				We sent you a link so you can record a few quick videos of your rooms.
				Please record on a mobile device.
			</p>
			<p>We will get back to you shortly to discuss your move.</p>
		</div>
	);
};

export default StartRecordingSuccess;
